<template>
  <div class="notification-view">

     <nav class="navbar has-border-bottom is-fixed-top" role="section">
      <!-- back -->
      <div class="container">
        <div class="navbar-brand">
          <BackButton></BackButton>
          <div class="navbar-item  mx-auto ">
            <p
              class="title has-text-weight-medium is-6"
            >{{ $t('ui.notification') }}</p>
          </div>
          <div class="ml-auto"></div>
        </div>
      </div>
    </nav>

    <!-- <div class="container">
      <h2 class="is-size-4 has-text-weight-semibold">{{$t('ui.favorites')}}</h2>
    </div> -->
    <div style="margin-top: 52px"></div>
<!--     
    <div class="container">
      <h2 class="is-size-4 has-text-weight-semibold">Bildirimler</h2>
    </div> -->

    <div class="has-text-centered" style="margin-top: 5rem">
      <p class="has-text-weight-medium">Bildirim kutun boş</p>
      <div class="is-block mt-1-half">
        <router-link class="button is-primary" :to="{name:'home'}">{{ $t('ui.continueToExplore') }}</router-link>
      </div>
    </div>
  </div>
</template>


<script>

import BackButton from "@/components/ui/BackButton";

export default {
  name: 'user-notification',
  components: {
   BackButton 
  },
  // data() {
  //   return {
  //     followings: [],
  //     isPageLoading: false,
  //   }
  // },
  // created() {
  //   this.fetchUserFollowings()
  // },
  // methods: {
  //   async fetchUserFollowings() {
  //     this.isPageLoading = true
  //     try {
  //       this.followings = await this.$store.dispatch('user/fetchUserFollows', { uid: '' }) 
  //     } catch (error) {
  //       console.log(error);   
  //     }
  //     this.isPageLoading = false
  //   }
  // }
}
</script>

<style lang="scss" scoped>

  .media + .media {
    margin-top: 0.5rem !important;
    padding-top: 0.5rem !important;
  }
</style>
